import { FormControl } from '@mui/material'
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import React from 'react'

const toMomentOrNull = (date) => {
  if (!date) return null
  if (moment.isMoment(date)) return date.clone()

  // STRICT ISO first (prevents "random" parsing)
  const iso = moment(date, moment.ISO_8601, true)
  if (iso.isValid()) return iso

  // If you have legacy strings, add formats you actually use:
  const legacy = moment(date, ['DD/MM/YYYY HH:mm', 'DD/MM/YYYY HH:mm:ss'], true)
  if (legacy.isValid()) return legacy

  return null
}

const AnDateTimePicker = ({
  label,
  date,
  value,
  onChange,
  fullWidth,
  size,
  required,
  error,
  helperText,
  ...props
}) => {
  const resolvedValue = toMomentOrNull(date ?? value)

  return (
    <FormControl fullWidth={fullWidth} size={size} required={required}>
      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en-gb">
        <DateTimePicker
          {...props}
          desktopModeMediaQuery="@media (min-width:0px)"
          label={label}
          value={resolvedValue}
          onChange={(newValue) => {
            if (newValue === null) {
              onChange?.(null)
              return
            }

            if (!moment.isMoment(newValue) || !newValue.isValid()) return
            onChange?.(newValue.toISOString())
          }}
          slotProps={{
            textField: { size, required, error, helperText },
            actionBar: { actions: ['clear', 'accept'] },
          }}
        />
      </LocalizationProvider>
    </FormControl>
  )
}

export default AnDateTimePicker
